// src/components/app/app-utils/txDelta.js
//
// Pure helper: compute how a transaction affects an account balance.
// This must stay in sync with the logic used in writers.

export function inferAccountDelta(tx, forAccountId) {
  const amt = Number(tx?.amount || 0);
  const type = String(tx?.type || "").toLowerCase();

  // Transfers (direction matters per account)
  if (type.includes("transfer")) {
    if (tx.transferSide === "OUT" && tx.accountId === forAccountId) return -Math.abs(amt);
    if (tx.transferSide === "IN" && tx.accountId === forAccountId) return +Math.abs(amt);
    return 0;
  }

  // Expenses / debits
  if (type.includes("expense") || type.includes("debit")) {
    return -Math.abs(amt);
  }

  // Income / credits / refunds
  if (type.includes("income") || type.includes("credit") || type.includes("refund")) {
    return +Math.abs(amt);
  }

  // Fallback
  return amt;
}
